/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyScheduleBlockedPeriodResponse } from './DutyScheduleBlockedPeriodResponse';
import {
    DutyScheduleBlockedPeriodResponseFromJSON,
    DutyScheduleBlockedPeriodResponseFromJSONTyped,
    DutyScheduleBlockedPeriodResponseToJSON,
    DutyScheduleBlockedPeriodResponseToJSONTyped,
} from './DutyScheduleBlockedPeriodResponse';
import type { DutyScheduleWeekdayPreferenceResponse } from './DutyScheduleWeekdayPreferenceResponse';
import {
    DutyScheduleWeekdayPreferenceResponseFromJSON,
    DutyScheduleWeekdayPreferenceResponseFromJSONTyped,
    DutyScheduleWeekdayPreferenceResponseToJSON,
    DutyScheduleWeekdayPreferenceResponseToJSONTyped,
} from './DutyScheduleWeekdayPreferenceResponse';

/**
 * 
 * @export
 * @interface DutyScheduleCounselorOptionResponse
 */
export interface DutyScheduleCounselorOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    userCode: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    lastName: string;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    weeklyHours: number;
    /**
     * 
     * @type {Array<DutyScheduleWeekdayPreferenceResponse>}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    dutyPreferences: Array<DutyScheduleWeekdayPreferenceResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    preferredCourtIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    excludedCourtIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    isConfigured: boolean;
    /**
     * 
     * @type {Array<DutyScheduleBlockedPeriodResponse>}
     * @memberof DutyScheduleCounselorOptionResponse
     */
    blockedPeriods: Array<DutyScheduleBlockedPeriodResponse>;
}

/**
 * Check if a given object implements the DutyScheduleCounselorOptionResponse interface.
 */
export function instanceOfDutyScheduleCounselorOptionResponse(value: object): value is DutyScheduleCounselorOptionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    if (!('dutyPreferences' in value) || value['dutyPreferences'] === undefined) return false;
    if (!('preferredCourtIds' in value) || value['preferredCourtIds'] === undefined) return false;
    if (!('excludedCourtIds' in value) || value['excludedCourtIds'] === undefined) return false;
    if (!('isConfigured' in value) || value['isConfigured'] === undefined) return false;
    if (!('blockedPeriods' in value) || value['blockedPeriods'] === undefined) return false;
    return true;
}

export function DutyScheduleCounselorOptionResponseFromJSON(json: any): DutyScheduleCounselorOptionResponse {
    return DutyScheduleCounselorOptionResponseFromJSONTyped(json, false);
}

export function DutyScheduleCounselorOptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleCounselorOptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userCode': json['userCode'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'weeklyHours': json['weeklyHours'],
        'dutyPreferences': ((json['dutyPreferences'] as Array<any>).map(DutyScheduleWeekdayPreferenceResponseFromJSON)),
        'preferredCourtIds': json['preferredCourtIds'],
        'excludedCourtIds': json['excludedCourtIds'],
        'isConfigured': json['isConfigured'],
        'blockedPeriods': ((json['blockedPeriods'] as Array<any>).map(DutyScheduleBlockedPeriodResponseFromJSON)),
    };
}

export function DutyScheduleCounselorOptionResponseToJSON(json: any): DutyScheduleCounselorOptionResponse {
    return DutyScheduleCounselorOptionResponseToJSONTyped(json, false);
}

export function DutyScheduleCounselorOptionResponseToJSONTyped(value?: DutyScheduleCounselorOptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userCode': value['userCode'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'weeklyHours': value['weeklyHours'],
        'dutyPreferences': ((value['dutyPreferences'] as Array<any>).map(DutyScheduleWeekdayPreferenceResponseToJSON)),
        'preferredCourtIds': value['preferredCourtIds'],
        'excludedCourtIds': value['excludedCourtIds'],
        'isConfigured': value['isConfigured'],
        'blockedPeriods': ((value['blockedPeriods'] as Array<any>).map(DutyScheduleBlockedPeriodResponseToJSON)),
    };
}

